export const TOKEN_COOKIE = "access_token";

export const setCookie = (
  name: string,
  value: string,
  maxAgeSeconds: number,
) => {
  document.cookie = `${name}=${value}; path=/; SameSite=Lax; max-age=${maxAgeSeconds}`;
};

export const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? match[1] : null;
};

export const deleteCookie = (name: string) => {
  document.cookie = `${name}=; path=/; SameSite=Lax; max-age=0`;
};
